module.exports = __webpack_public_path__ + "e941e22b7c9f125755c70dc0bcfa327a.svg";